// Client helper to submit a report via the secure submit_report RPC.
// Server attaches: last 30 messages, latest NSFW frame, risk_at_report.
import { supabase } from "@/integrations/supabase/client";

export type ReportType = "profile" | "chat" | "video";

export interface SubmitReportOpts {
  reportedUserId: string;
  reason: string;
  reportType?: ReportType;
  sessionChannel?: string;
  conversationId?: string;
}

export async function submitReport(opts: SubmitReportOpts): Promise<{ ok: boolean; error?: string; id?: string }> {
  console.log("[reports] submitting", opts);
  const { data, error } = await supabase.rpc("submit_report" as any, {
    p_reported_id: opts.reportedUserId,
    p_reason: opts.reason,
    p_report_type: opts.reportType ?? "profile",
    p_session_channel: opts.sessionChannel ?? null,
    p_conversation_id: opts.conversationId ?? null,
  });
  if (error) {
    console.warn("[reports] submit_report failed:", error);
    return { ok: false, error: error.message };
  }
  return { ok: true, id: data as string };
}
